export function toAgreementListParts(agreements, locale) {
    return new Intl.ListFormat(locale, {
        type: 'unit'
    }).formatToParts(agreements.map((_agreement, position)=>String(position))).map((part, index)=>part.type === 'element' ? {
            type: 'agreement',
            agreement: agreements[Number(part.value)]
        } : {
            type: 'separator',
            key: "separator-".concat(index),
            text: part.value
        });
}
